<template>
    <div class="container">
        <card
            header-text="Descargar Reporte MinTic"
            class="col-md-8 offset-md-2">
            <div class="card-body card-block">
                <span>Aquí podrás descargar el reporte generado para el MinTic</span>
                <button class="btn btn-block btn-info mt-5" @click="onClick">Descargar Reporte Voluntarios</button>
                <button class="btn btn-block btn-info mt-5" @click="onClickInspirados">Descargar Reporte Inspirados</button>
            </div>
        </card>
    </div>
</template>
<script>
import { obtenerReporteMinTic, obtenerReporteMinTicInspirados } from '../../api/admin'
export default {
  methods: {
    async onClick () {
      await obtenerReporteMinTic()
    },
    async onClickInspirados () {
      await obtenerReporteMinTicInspirados()
    }
  }
}
</script>
